import classNames from 'classnames'
import {
  GatsbyImage,
  IGatsbyImageData,
  withArtDirection
} from 'gatsby-plugin-image'
import React from 'react'

import * as styles from './image-art-direction.module.scss'

type Props = {
  image: Record<string, unknown> | null | undefined
  imageMobile: Record<string, unknown> | null | undefined
  alt: string
  className: string | undefined
}
export const ImageArtDirection: React.FC<Props> = ({
  image,
  imageMobile,
  alt,
  className = ''
}) => {
  if (!image) {
    return <></>
  }
  if (!imageMobile) {
    return (
      <GatsbyImage
        className={classNames(className)}
        image={image as unknown as IGatsbyImageData}
        alt={alt}
      />
    )
  }
  const images = withArtDirection(image as unknown as IGatsbyImageData, [
    {
      media: '(max-width: 992px)',
      image: imageMobile as unknown as IGatsbyImageData
    }
  ])
  return (
    <GatsbyImage
      className={classNames(styles.artdirected, className)}
      image={images}
      alt={alt}
    />
  )
}

export default ImageArtDirection
